import { PromoBanner } from '../PromoBanner';

type TMidnightAddonsUpsellProps = {
  className?: string;
};

export function MidnightAddonsUpsell(props: TMidnightAddonsUpsellProps) {
  return (
    <PromoBanner
      className={props.className}
      url="https://rio.gg/MIDNIGHTAddons_"
      blurb={'\u{1F527} Get your UI ready for Midnight Season 1! Browse our curated list of must-have AddOns for Mythic+, raiding, and more \u2014 updated for the new AddOn changes. \u2694\uFE0F'}
      buttonText="Browse the List"
      trackingSlug="midnight_addons_upsell"
      imagePath="/images/upsells/midnight-addons/banner.webp"
      imageAlt="Must-Have AddOns for Midnight"
    />
  );
}
